"use strict";

var userAgent = navigator.userAgent;
var isWinOS = userAgent.indexOf("Windows Phone") > -1;
var isYouthCtripApp = userAgent.indexOf("Youth_CtripWireless") > -1;
var isCtripApp = userAgent.indexOf("_CtripWireless") > -1;
var isFunction = function isFunction(fn) {
    return typeof fn === 'function';
};
var namespace = 'ctrip';
var eventsAPI = ['onShow', 'onReceiveData', 'onceReceiveData', 'onNavClick', 'onceNavClick'];

var __CTRIP_JS_PARAM = "?jsparam=";
var __CTRIP_URL_PLUGIN = "ctrip://h5/plugin" + __CTRIP_JS_PARAM;
var __CTRIP_YOUTH_URL_PLUGIN = "ctripyouth://h5/plugin" + __CTRIP_JS_PARAM;
var __CTRIP_AUTH_HEAD = 'ctrip-auth-head';
var __CTRIP_AUTH_VALUE = 'ctrip-auth';

var apis = require('./apis/');
var bridge = require('./lib/bridge.js');
var events = require('./lib/events.js');
var custEvent = require('./lib/custEvent.js');

var getCallback = function getCallback(options, debug) {
    options = options || {};
    var successCb = options.success,
        failCb = options.fail,
        completeCb = options.complete;
    delete options.success;
    delete options.fail;
    delete options.complete;
    return function (data) {
        debug && console.info("[HySDK] Ctrip Callback Data:", data);
        if (!data || typeof data.ret === 'undefined') {
            isFunction(successCb) && successCb(data);
        } else if (data.ret) {
            isFunction(successCb) && successCb(data.data);
        } else {
            isFunction(failCb) && failCb(data);
        }
        isFunction(completeCb) && completeCb(data);
    };
};

var bind = function bind(sdk, key, fns) {
    var process = function process(options) {
        var fn = fns[key][namespace];
        return fn.call(sdk, options);
    };
    return function (options) {
        return sdk.isReady ? sdk.env === namespace && process(options) : sdk.ready(function () {
            return sdk.env === namespace && process(options);
        });
    };
};

var checkEnv = function checkEnv(sdk) {
    var sniff = sdk.sniff;

    if (isCtripApp) {
        sdk.env = namespace;
    }

    sdk.util.extend(sniff, {
        winos: isWinOS,
        youthCtripApp: isYouthCtripApp,
        ctripApp: isCtripApp,
        ctripUseBase64: false
    });

    if (isCtripApp) {
        if (userAgent.indexOf('eb64') > -1) {
            sniff.ctripUseBase64 = true;
        } else {
            var m = userAgent.match(/_CtripWireless_([^\.]+\.\d)/);
            if (m && m[1] && parseInt(m[1].replace('.', '')) >= 62) {
                sniff.ctripUseBase64 = true;
            }
        }
        sniff.bridgeScheme = isYouthCtripApp ? __CTRIP_YOUTH_URL_PLUGIN : __CTRIP_URL_PLUGIN;
    }
};

module.exports = function (config) {
    var sdk = this,
        fns = sdk.fns = sdk.fns || {},

    /**
     * Ajax
     * @method hysdk.ajax
     * @category Fusion:Util
     * @description
     * Ajax 工具方法，支持普通请求，以及 Ctrip Hybrid 方案下的 ajax（在 method 为 post 且 argsType 为 json 时， 自动添加 AuthHead）。
     *
     * 基本配置如下:
     *
     * ```
     * {
     *      "charset": "UTF-8",
     *      "timeout": 30 * 1000,
     *      "argsType": "json", // 注意
     *      "method": "post", // 注意
     *      "isEncode": false,
     *      "responseType": "json",
     *      "withCredentials": false
     * }
     * ```
     *
     * 配置参数：
     *
     *    * `url`: `{String}` 请求地址。
     *    * `charset`: `{String}` 编码。默认 `UTF-8` 。
     *    * `timeout`: `{Number}` 请求超时时间。默认 `30 * 1000` 。
     *    * `data`: `{Object}` 请求参数。
     *    * `argsType`: `{String}` 请求参数类型。可选值：`query` 和 `json`。默认 `json` 。
     *    * `method`: `{String}` 请求方式。默认 `post` 。
     *    * `headers`: `{Object}` 请求头信息。
     *    * `isEncode`: `{Boolean}` 否是编码。默认 `false` 。
     *    * `dataType`: `{String}` 返回数据的数据类型。默认 `json` 。
     *    * `cache`: `{Boolean}` 是否允许缓存。默认 `false` 。
     *    * `withCredentials`: `{Boolean}` 是否带有验证信息。默认 `false` 。
     *    * `defaultProtocolInFile`: `{String}` 在 File 协议下，缺省协议头时默认采用的协议。默认 `https`。
     *    * `jsonp`: `{String}` 为 jsonp 请求重写回调函数名对应的 key。这个值用来替代在 url 中"callback=?"的"callback"部分。
     *    * `jsonpCallback`: `{String}` 为 jsonp 请求指定一个回调函数名。这个值将用来取代自动生成的随机函数名。
     *    * `success`: `{Function}` 请求成功后的函数调用。
     *    * `error`: `{Function}` 请求失败后的函数调用。
     *    * `onAbort`: `{Function}` 取消请求后的函数调用。
     *    * `onFail`: `{Function}` 请求失败后的函数调用。
     *
     * 其他API:
     *
     * > hysdk.ajax.addReqFilter(filter)
     *
     *  说明：添加请求参数的过滤函数
     *
     *  > hysdk.ajax.removeReqFilter(filter)
     *
     *  说明：移除某个请求时的过滤参数
     *
     *  > hysdk.ajax.addRespFilter(filter)
     *
     *  说明：添加数据的过滤函数
     *
     *  > hysdk.ajax.removeRespFilter(filter)
     *
     *  说明：移除数据的过滤函数
     *
     */
    ajax = sdk.ajax = require('./util/ajax.js'),
        head = {};

    var setAuth = function setAuth(data) {
        if (data && data.data && data.data.Auth) {
            if (head && head.value) {
                head.value.auth = data.data.Auth;
            }
        }
    };

    checkEnv(sdk);

    // checkJsApi
    /**
     * 判断当前环境是否支持指定JS接口
     * @method hysdk.checkJsApi
     * @category Fusion:Base
     * @description
     * 与 Hy 环境用法、参数格式相同
     */
    sdk.ctrip = sdk.util.extend({
        checkJsApi: bind(sdk, 'checkJsApi', fns)
    }, custEvent);
    eventsAPI.forEach(function (api) {
        return apis[api] = true;
    });
    fns.checkJsApi = fns.checkJsApi || {};
    fns.checkJsApi.ctrip = function (options) {
        var list = [].concat(options.jsApiList),
            data = {};
        list.forEach(function (v) {
            if (v === 'checkJsApi') {
                data.checkJsApi = true;
            } else {
                data[v] = !!apis[v];
            }
        });
        options.success && options.success(data);
    };

    // init apis
    Object.keys(apis).forEach(function (api) {
        sdk[namespace][api] = bind(sdk, api, fns);
    });

    /**
     * 获取 Auth 信息
     * @method hysdk.getAuthHead
     * @category Fusion:Util
     * @description
     * 使用 Ajax Post 请求并且参数形式为 JSON 时，会将 AuthHead 加到参数中。
     * 其他请求业务自主获取 Auth，与后端约定数据交互形式。
     */
    sdk.getAuthHead = function () {
        return head;
    };

    /**
     * 获取 Auth 信息
     * @method hysdk.getFixedUrl
     * @category Fusion:Util
     * @description
     * 将 url 转换为本地路径，适用于 Ctrip App Hybrid 方案。
     */
    sdk.getFixedUrl = function (url) {
        if (isCtripApp && location.href.indexOf('/webapp_work_') > -1 && location.protocol === 'file:') {
            var k = location.href.split('/webapp_work_'),
                baseUrl = k[0] + '/webapp_work_' + k[1].split('/').slice(0, 2).join('/');
            return baseUrl + '/' + url.split('//')[1];
        }
        return url;
    };

    if (isCtripApp) {
        sdk.bridge = bridge(sdk, config);
        events(sdk, config);
        Object.keys(apis).forEach(function (api) {
            var conf = apis[api];
            if (conf) {
                fns[api] = fns[api] || {};
                fns[api][namespace] = function (opt) {
                    opt = opt || {};
                    var callback = getCallback(opt, config.debug);
                    if (conf.exec) {
                        conf.exec.call(sdk, opt, callback);
                    } else {
                        if (conf.optHandle) {
                            opt = conf.optHandle(opt || {});
                        }
                        sdk.bridge.invoke(conf.service, conf.action, opt, conf.tagname, function (res) {
                            var rs = conf.resHandle ? conf.resHandle(res, opt) : res;
                            // 模拟 hide
                            if (api === 'openWebView' || api === 'openWindow') {
                                sdk.ctrip.trigger('hide');
                            }
                            rs._originData = res;
                            if (api === 'login') {
                                setAuth(res);
                            }
                            callback(rs);
                        });
                    }
                };
            }
        });

        sdk.login = sdk[namespace].login;
        sdk.logout = sdk[namespace].logout;
        sdk.checkLogin = function (opts) {
            opts = opts || {};
            sdk.bridge.invoke("User", "memberAutoLogin", {}, 'member_auto_login', function (data) {
                setAuth(data);
                if (isFunction(opts.success)) {
                    opts.success({
                        ret: true,
                        login: !!data.data
                    });
                }
            });
        };
        sdk.getUserInfo = function (opts) {
            opts = opts || {};
            sdk.bridge.invoke("User", "memberAutoLogin", {}, 'member_auto_login', function (data) {
                setAuth(data);
                if (isFunction(opts.success)) {
                    opts.success({
                        ret: true,
                        data: data.data
                    });
                }
            });
        };

        ajax.addReqFilter(function (opt) {
            opt.headers[__CTRIP_AUTH_HEAD] = JSON.stringify(head);
            if (head && head.value && head.value.auth) {
                opt.headers[__CTRIP_AUTH_VALUE] = head.value.auth || '';
            }
        });

        try {
            head = JSON.parse(localStorage.HEADSTORE);
        } catch (e) {
            config.debug && conole.warn('[HySDK] HEADSTORE cannot parse.');
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ../plugins/ctrip/index.js
// module id = 41
// module chunks = 1 4